import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "launch",
  computed: {
    ...walletVuex.mapState(["isMobile"])
  },
  methods: {},
  async mounted() {}
};